const SELECTMANUALSERVICE_UPDATED = (state, SelectManualService) => {
  state.SelectManualService = SelectManualService
}

const REBOOK_GET = (state, Rebook) => {
  state.Rebook = Rebook
}

const PAXS_GROUP = (state, PaxsGroup) => {
  state.PaxsGroup = PaxsGroup
}

export default {
  SELECTMANUALSERVICE_UPDATED,
  REBOOK_GET,
  PAXS_GROUP
}
